import { z } from "zod";
import { ISODateSchema } from "./primitives.js";
export const PingResponseSchema = z.object({
    ok: z.literal(true),
    now: ISODateSchema,
    version: z.string(),
});
//# sourceMappingURL=ping.js.map